// import { download } from 'libs/jamUtil'
import helper from 'pages/main/components/Attachment/helper'
import type { Attachment as HelperAttachment } from 'pages/main/components/Attachment/helper'

// Type definitions for attachment data structures
interface DataForJSON {
  id: string
  name: string
  size: number
  mime_type: string
  cid?: string
  status?: string
  enable_preview?: boolean
  enable_open?: boolean
  enable_save_as?: boolean
}

// Extended attachment type with dataForJSON property
interface Attachment extends HelperAttachment {
  dataForJSON: DataForJSON
}

interface EMLFileData {
  filename: string
  content: ArrayBuffer
  mimeType: string
}

/**
 * Creates an attachment object from an origin file
 * @param originFile - The original file object
 * @param cid - Content ID for inline attachments (optional)
 * @param idx - Index for generating unique IDs
 * @returns Attachment object with file data and metadata
 */
const createAttachment = (originFile: File, cid: string | null, idx: number): Attachment => {
  const id = cid == null ? `attachment_${idx}` : `inline_${idx}`
  const attachment = helper.createAttachment(originFile, cid, null) as Attachment
  attachment.id = id

  const dataForJSON: DataForJSON = {
    id: attachment.id,
    name: attachment.file.name,
    size: attachment.file.size,
    mime_type: attachment.file.type,
  }

  if (cid != null) {
    dataForJSON.cid = cid
  } else {
    dataForJSON.status = 'none'
    // 무조건 preview를 true로 설정 - preview가 안되는 것은 download로 처리.
    dataForJSON.enable_preview = helper.isPreviewEnable(originFile)

    if (__ENV_LOCAL__) {
      dataForJSON.enable_open = true
      dataForJSON.enable_save_as = true
    }
  }

  attachment.dataForJSON = dataForJSON

  return attachment
}

/**
 * Creates an attachment object from an EML file
 * @param originFile - The EML file object with filename, content, and mimeType
 * @param contentId - Content ID for inline attachments (optional)
 * @param idx - Index for generating unique IDs
 * @returns Attachment object with file data and metadata
 */
const createAttachmentForEML = (
  originFile: EMLFileData,
  contentId: string | null,
  idx: number,
): Attachment => {
  const id = contentId == null ? `attachment_${idx}` : `inline_${idx}`
  const attachment = helper.createAttachmentForEML(originFile, contentId, null) as Attachment
  attachment.id = id

  const dataForJSON: DataForJSON = {
    id: attachment.id,
    name: attachment.file.name,
    size: attachment.file.size,
    mime_type: attachment.file.type,
  }

  if (contentId != null) {
    dataForJSON.cid = contentId
  } else {
    dataForJSON.status = 'none'
    // 무조건 preview를 true로 설정 - preview가 안되는 것은 download로 처리.
    dataForJSON.enable_preview = helper.isPreviewEnable(originFile as any)

    if (__ENV_LOCAL__) {
      dataForJSON.enable_open = true
      dataForJSON.enable_save_as = true
    }
  }

  attachment.dataForJSON = dataForJSON

  return attachment
}

const helperExt = {
  createAttachment,
  createAttachmentForEML,
}

export default helperExt
